/**
 * Shown in two situations, and it has to read sensibly in both:
 *
 *   1. The operator opened a screen they were not granted - a stale link, a
 *      bookmark, a page that was taken off them. They still have a menu, and
 *      the offer is to go back to a page they do hold.
 *   2. They hold NO pages at all, so `/home` lands them here. There is nowhere
 *      to send them, and the only useful thing to say is who to ask.
 *
 * Until the permission work landed, this component was imported in two route
 * files and rendered by neither: the check that would have used it was
 * commented out in both. It was also the only screen in the CMS whose text was
 * in English, with a "Go Back Home" link to `/` - which, for a signed-in
 * operator, bounces straight back into the CMS and could land them here again.
 *
 * TEXT ONLY. The illustration (`NoPermissionImg.svg`) was dropped: it filled
 * the content area and made a routine administrative state look like a fault.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import styles from './NoPermission.module.css';
import { usePageAccess } from '../../../Context/PageAccessContext';
import { NO_PERMISSION_PATH } from '../../../services/pageAccess';

const NoPermission = () => {
  const { landing } = usePageAccess();

  // `landing` is this very screen when the operator holds nothing, and a link
  // back to where you already are is worse than no link.
  const hasSomewhereToGo = landing && landing !== NO_PERMISSION_PATH;

  return (
    <div className={styles.container} dir='rtl'>
      <div className={styles.panel}>
        <span className={styles.rule} />

        <h2 className={styles.title}>
          {hasSomewhereToGo
            ? 'لا تملك صلاحية الوصول إلى هذه الصفحة'
            : 'لا توجد صفحات مخصصة لحسابك'}
        </h2>

        <p className={styles.message}>
          {hasSomewhereToGo
            ? 'هذه الصفحة غير مُخصَّصة لحسابك. يمكنك العودة إلى صفحاتك، أو التواصل مع مسؤول النظام إذا كنت بحاجة إلى صلاحية الوصول إليها.'
            : 'لم يتم تخصيص أي صفحة لحسابك حتى الآن. يرجى التواصل مع مسؤول النظام لمنحك الصلاحيات اللازمة.'}
        </p>

        {hasSomewhereToGo && (
          <Link to={landing} className={styles.action}>
            العودة إلى صفحتي الرئيسية
          </Link>
        )}
      </div>
    </div>
  );
};

export default NoPermission;
